import { Navigate, Route, Routes } from 'react-router-dom';
import CreateProductPage from './edit/CreateProductPage';
import EditProductPage from './edit/EditProductPage';
import ProductListPage from './list/ProductListPage';

export default function ProductsRouter() {
  return (
    <Routes>
      <Route element={<ProductListPage />} index />
      <Route element={<CreateProductPage />} path="create/*" />
      <Route element={<EditProductPage />} path=":productId/*" />
      <Route element={<Navigate to="" />} path="*" />
    </Routes>
  );
}
